import * as React from "react";
import { cn } from "../../lib/utils";

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Col = React.forwardRef<HTMLDivElement, ColProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex flex-col gap-4", className)}
      {...props}
    />
  )
);